export default __webpack_public_path__ + "static/media/fiolet_pult.caac6c31.svg";